import React, { useMemo } from "react";
import { AsideMenuList } from "../../containers/aside-menu-container/AsideMenuList";
import { useHtmlClassService } from "../../../_metronic/layout/_core/MetronicLayout";

export function AsideMenu() {
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      asideMenuAttr: uiService.getAttributes("aside_menu"),
      ulClasses: uiService.getClasses("aside_menu_nav", true),
      asideClassesFromConfig: uiService.getClasses("aside_menu", true),
    };
  }, [uiService]);

  return (
    <>
      <div
        id="kt_aside_menu"
        data-menu-vertical="1"
        className={`aside-menu ${layoutProps.asideClassesFromConfig}`}
        style={{ overflowY: "auto", maxHeight: "80vh" }}
        {...layoutProps.asideMenuAttr}
      >
        <AsideMenuList layoutProps={layoutProps} />
      </div>
    </>
  );
}
